import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AwardIcon } from 'lucide-react';
import { useProgress, Badge } from '../hooks/useProgress';
import { BadgeCard } from './BadgeCard';
import { BadgeDetailModal } from './BadgeDetailModal';
export function BadgesSection() {
  const {
    getAllBadges
  } = useProgress();
  const badges = getAllBadges();
  const earnedCount = badges.filter(b => b.isEarned).length;
  const [selectedBadge, setSelectedBadge] = useState<Badge | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleBadgeClick = (badge: Badge) => {
    setSelectedBadge(badge);
    setIsModalOpen(true);
  };
  return <div className="mb-8" data-id="element-264">
      <div className="flex items-center justify-between mb-6" data-id="element-265">
        <div className="flex items-center space-x-3" data-id="element-266">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-md" data-id="element-267">
            <AwardIcon className="w-6 h-6 text-white" data-id="element-268" />
          </div>
          <div data-id="element-269">
            <h2 className="text-xl sm:text-2xl font-bold text-[#132C53]" data-id="element-270">
              Insigne Câștigate
            </h2>
            <p className="text-sm text-gray-600" data-id="element-271">
              Colecționează insigne pentru fiecare modul finalizat
            </p>
          </div>
        </div>
        <div className="bg-amber-100 text-amber-800 px-4 py-2 rounded-full font-bold text-sm" data-id="element-272">
          {earnedCount} / {badges.length}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6" data-id="element-273">
        {badges.map((badge, index) => <motion.div key={badge.id} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.05
      }} data-id="element-274">
            <BadgeCard badge={badge} onClick={() => handleBadgeClick(badge)} data-id="element-275" />
          </motion.div>)}
      </div>

      <BadgeDetailModal badge={selectedBadge} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-276" />
    </div>;
}